export const RECEIVE_PARTNERS_DATA = 'RECEIVE_PARTNERS_DATA';
export const GET_PARTNER_DATA = 'GET_PARTNER_DATA';
